<template>
  <div v-loading="loading">
    <headBox title="详情" :showBack="true"></headBox>
    <div class="tbd-content">
      <div class="tb-card">
        <div class="card-head clearfix">
          <div class="title1">
            <span v-if="renewalType == '1'">客户{{ detailList.renewalStatus | filterXbStatus }}，原保单{{ all.POLICY_STATUS[detailList.policyStatus] }}</span>
            <span v-if="renewalType == '2'">客户第{{ detailList.curRenewalTimes }}期{{ detailList.renewalStatus | filterRenewal }}</span>
            <template v-if="detailList.renewalFailReason">
              <span v-if="detailList.renewalStatus == 2">，原因：{{ detailList.renewalFailReason }}</span>
              <span v-else-if="detailList.renewalStatus >= 6">，失败原因：{{ detailList.renewalFailReason }}</span>
            </template>
          </div>
          <div class="title2" v-if="userinfo.level != 3">
            <div v-if="['1', '2'].includes(mechanLevel)">
              <tooltip class="val-right" :txt-info="`出单团队：${mechanName}`"></tooltip>
            </div>
            <div v-else>
              <tooltip class="val-right" :txt-info="`出单员工：${mechanName}`"></tooltip>
            </div>
          </div>
        </div>
        <div class="card-body clearfix">
          <!-- 长险续费单 -->
          <div class="card-left" v-if="renewalType == '2'">
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">投保产品</div>
                <tooltip class="val-right" :txt-info="detailList.productName | filterNull"></tooltip>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">投保日期</div>
                <div class="val-right">
                  {{ detailList.payTime | timeSplit }}
                </div>
              </div>
            </div>

            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">保单号</div>
                <div class="val-right">
                  <tooltip :txt-info="detailList.policyNo | filterNull"></tooltip>
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">保单状态</div>
                <div class="val-right">
                  {{ all.POLICY_STATUS[detailList.policyStatus] | filterNull }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">微信昵称</div>
                <!-- <div class="val-right">
                  {{ detailList.nickname | filterNull }}
                </div> -->
                <tooltip class="val-right" :txt-info="detailList.nickname | filterNull"></tooltip>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">续费期数</div>
                <div class="val-right">
                  {{ detailList.curRenewalTimes | filterNull }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">续费状态</div>
                <div class="val-right">
                  {{ detailList.renewalStatus | filterRenewal }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">继续率要求</div>
                <div class="val-right">92%</div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">应续费日期</div>
                <div class="val-right">
                  {{ detailList.needPayTime | timeSplit }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">宽限期满日</div>
                <div class="val-right">
                  {{ detailList.lastPayTime | timeSplit }}
                </div>
              </div>
            </div>
            <!-- 续费成功才显示 -->
            <div class="card-row" v-if="detailList.renewalStatus == 5">
              <div class="card-cell">
                <div class="lab-left">实际续费日期</div>
                <div class="val-right">
                  {{ detailList.renewalTime | timeSplit }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">续期应交保费</div>
                <div class="val-right">
                  {{ detailList.needPayFee | filterNull }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">续期实交保费</div>
                <div class="val-right">
                  {{ detailList.payFee | filterNull }}
                </div>
              </div>
            </div>
            <div class="card-row" v-if="employee">
              <div class="card-cell">
                <div class="lab-left">服务费</div>
                <div class="val-right">{{ detailList.incomes | filterNull }}元</div>
              </div>
            </div>
            <div class="card-row full">
              <div class="card-cell">
                <div class="lab-left">跟进备注</div>
                <div class="val-right">{{ detailList.renewalRemark | filterNull }}</div>
              </div>
            </div>
          </div>

          <!-- 短险续保单 -->
          <div class="card-left" v-else>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">投保产品</div>
                <tooltip class="val-right" :txt-info="detailList.productName | filterNull"></tooltip>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">续保状态</div>
                <div class="val-right">
                  {{ detailList.renewalStatus | filterXbStatus }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">微信昵称</div>
                <div class="val-right">
                  {{ detailList.nickname | filterNull }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">原保单号</div>
                <!-- <div class="val-right">{{ detailList.policyNo |filterNull}}</div> -->
                <div class="val-right"><tooltip :txt-info="detailList.policyNo | filterNull"></tooltip></div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">原单状态</div>
                <div class="val-right">
                  {{ all.POLICY_STATUS[detailList.policyStatus] | filterNull }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">新保单号</div>
                <div class="val-right" v-if="!detailList.newPolicyNo">-</div>
                <div class="val-right" v-show="detailList.newPolicyNo && detailList.newPolicyNo.length <= 15">{{ detailList.newPolicyNo | filterNull }}</div>
                <el-tooltip class="item" effect="dark" placement="top">
                  <div class="val-right" v-show="detailList.newPolicyNo && detailList.newPolicyNo.length > 15">
                    {{ detailList.newPolicyNo ? detailList.newPolicyNo.substr(0, 15) : '-' }}
                    <span class="ellipsis">...</span>
                  </div>
                  <div class="tips" slot="content">{{ detailList.newPolicyNo }}</div>
                </el-tooltip>
              </div>
            </div>

            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">新单状态</div>
                <div class="val-right">
                  {{ all.POLICY_STATUS[detailList.newPolicyStatus] | filterNull }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">原单到期日</div>
                <div class="val-right">
                  {{ detailList.oldEndTime | timeSplit }}
                </div>
              </div>
            </div>
            <div class="card-row" v-if="detailList.renewalStatus == 5">
              <div class="card-cell">
                <div class="lab-left">新单续保时间</div>
                <div class="val-right">
                  {{ detailList.renewalTime | timeSplit }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">犹豫到期</div>
                <div class="val-right">
                  {{ detailList.waverLimitDate }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">起保日期</div>
                <div class="val-right">
                  {{ detailList.startTime | timeSplit }}
                </div>
              </div>
            </div>

            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">终保日期</div>
                <div class="val-right">
                  {{ detailList.endTime | timeSplit }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">保障额度</div>
                <div class="val-right">
                  {{ detailList.totalInsured | filterNull }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">保障期限</div>
                <div class="val-right">
                  <span v-if="detailList.guarateeLimit != 106">{{ detailList.guarateeLimit }}</span>
                  <span>{{ detailList.guarateeType | guarateeType }}</span>
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">原单保费</div>
                <div class="val-right">
                  {{ detailList.oldFee | filterNull }}
                </div>
              </div>
            </div>

            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">续保保费</div>
                <div class="val-right">{{ detailList.newFee | filterNull }}</div>
              </div>
            </div>
            <div class="card-row" v-if="employee">
              <div class="card-cell">
                <div class="lab-left">服务费</div>
                <div class="val-right">{{ detailList.incomes | filterNull }}</div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">交费方式</div>
                <div class="val-right">{{ detailList.payType | filterPayType }}</div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">交费期限</div>
                <div class="val-right">{{ all.PAYMENT_TYPE[detailList.payment] }}</div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">银行卡号</div>
                <div
                  class="val-right"
                  :class="{ 'can-click': detailList.isDecrypt && detailList.accountNumber }"
                  @dblclick="
                    detailList.accountNumber && detailList.isDecrypt && descrypt(1, 3, detailList.accountNumberMd5, policyNo, 'accountNumber', detailList)
                  "
                >
                  {{ detailList.accountNumber | filterNull }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">持卡人</div>
                <div class="val-right">{{ detailList.policyerName | filterNull }}</div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">开户行</div>
                <div class="val-right">{{ detailList.accountBank | filterNull }}</div>
              </div>
            </div>
            <div class="card-row full">
              <div class="card-cell">
                <div class="lab-left">跟进备注</div>
                <div class="val-right">{{ detailList.renewalRemark | filterNull }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tb-info">
        <el-tabs v-model="activeName">
          <el-tab-pane label="投保信息" name="first">
            <div class="tb-info-card" v-if="renewalType == '2'">
              <div class="card-body card-body-padding">
                <div class="info-row">
                  <div class="info-lab">保障额度</div>
                  <div class="info-val">{{ detailList.totalInsured | filterNull }}元</div>
                </div>
                <div class="info-row">
                  <div class="info-lab">保障期限</div>
                  <div class="info-val">
                    <span v-if="detailList.guarateeLimit != 106">{{ detailList.guarateeLimit }}</span>
                    <span>{{ detailList.guarateeType | guarateeType }}</span>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">起保日期</div>
                  <div class="info-val">
                    {{ detailList.startTime | timeSplit }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">终保日期</div>
                  <div class="info-val">
                    {{ detailList.endTime | timeSplit }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">犹豫到期</div>
                  <div class="info-val">
                    {{ detailList.waverLimitDate }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">交费方式</div>
                  <div class="info-val">
                    {{ detailList.payType | filterPayType }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">交费期限</div>
                  <div class="info-val" v-if="detailList.payment == 4 || detailList.payment == 5">
                    {{ detailList.payment | filterPayment }}
                  </div>
                  <div class="info-val" v-else>{{ detailList.payPerm }}{{ all.PAYMENT_TYPE[detailList.payment] }}</div>
                </div>
              </div>
            </div>
            <div class="tb-info-card">
              <div class="tb-info-title">投保人信息</div>
              <div class="card-body card-body-padding">
                <div class="info-row">
                  <div class="info-lab">姓名</div>
                  <div class="info-val">{{ detailList.policyerName | filterNull }}</div>
                </div>
                <div class="info-row">
                  <div class="info-lab">性别</div>
                  <div class="info-val">
                    {{ detailList.holderSex == '1' ? '男' : detailList.holderSex == '2' ? '女' : '-' }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">出生日期</div>
                  <div class="info-val">{{ detailList.holderBirthday | filterNull }}</div>
                </div>
                <div class="info-row">
                  <div class="info-lab">证件类型</div>
                  <div class="info-val">
                    {{ all.CARD_TYPE[detailList.policyerCardType] | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">证件号码</div>
                  <div
                    class="info-val"
                    :class="{ 'can-click': detailList.isDecrypt && detailList.policyerIdCard }"
                    @dblclick="
                      detailList.policyerIdCard && detailList.isDecrypt && descrypt(1, 1, detailList.policyerIdCardMd5, policyNo, 'policyerIdCard', detailList)
                    "
                  >
                    {{ detailList.policyerIdCard | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">手机号码</div>
                  <div
                    class="info-val"
                    :class="{ 'can-click': detailList.isDecrypt && detailList.policyerMobile }"
                    @dblclick="
                      detailList.policyerMobile && detailList.isDecrypt && descrypt(1, 2, detailList.policyerMobileMd5, policyNo, 'policyerMobile', detailList)
                    "
                  >
                    {{ detailList.policyerMobile | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">电子邮箱</div>
                  <div
                    class="info-val"
                    :class="{ 'can-click': detailList.isDecrypt && detailList.holderEmail }"
                    @dblclick="detailList.holderEmail && detailList.isDecrypt && descrypt(1, 9, detailList.holderEmailMd5, policyNo, 'holderEmail', detailList)"
                  >
                    {{ detailList.holderEmail | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">所在地区</div>
                  <tooltip class="info-val" :txt-info="detailList.holderArea | holderArea"></tooltip>
                </div>
                <div class="info-row mt" style="width: 100%">
                  <div class="info-lab">详细地址</div>
                  <tooltip
                    class="info-val"
                    :class="{ 'can-click': detailList.isDecrypt && detailList.holderHomeAddress }"
                    @dblclick="
                      detailList.holderHomeAddress &&
                        detailList.isDecrypt &&
                        descrypt(1, 8, detailList.holderHomeAddressMd5, policyNo, 'holderHomeAddress', detailList)
                    "
                    :txt-info="detailList.holderHomeAddress | holderHomeAddress"
                  ></tooltip>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="被保险人及权益" name="second">
            <div class="tb-info-card">
              <div class="tb-info-title">被保险人</div>
              <template v-if="insuredersJson.length != 0">
                <div class="card-body bbxr-card-body clearfix" v-for="(bean, i) in insuredersJson" :key="i">
                  <div class="triangle-topleft">
                    <span>{{ i + 1 }}</span>
                  </div>
                  <div class="info-box">
                    <div class="info-row">
                      <div class="info-lab">姓名</div>
                      <div class="info-val">{{ bean.insurederName | filterNull }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-lab">性别</div>
                      <div class="info-val">
                        {{ bean.insurederSex == '1' ? '男' : bean.insurederSex == '2' ? '女' : '-' }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-lab">出生日期</div>
                      <div class="info-val">{{ bean.insurederBirthday | filterNull }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-lab">证件号码</div>
                      <div
                        class="info-val"
                        :class="{ 'can-click': detailList.isDecrypt && bean.insurederIdCardMask }"
                        @dblclick="
                          bean.insurederIdCardMask && detailList.isDecrypt && descrypt(1, 2, bean.insurederIdCardMd5, policyNo, 'insurederIdCardMask', bean)
                        "
                      >
                        {{ bean.insurederIdCardMask | filterNull }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-lab">手机号码</div>
                      <div
                        class="info-val"
                        :class="{ 'can-click': detailList.isDecrypt && bean.insuranceMobile }"
                        @dblclick="bean.insuranceMobile && detailList.isDecrypt && descrypt(1, 2, bean.insuranceMobileMd5, policyNo, 'insuranceMobile', bean)"
                      >
                        {{ bean.insuranceMobile | filterNull }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-lab">证件类型</div>
                      <div class="info-val">{{ all.CARD_TYPE[bean.insurederCardType] | filterNull }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-lab">与投保人关系</div>
                      <div class="info-val">
                        {{ bean.insuredRelationship | beneRelationship }}
                      </div>
                    </div>
                  </div>
                  <div class="ckqy-content">
                    <el-button class="ckqy-btn" type="text" @click="getGarmteeDetail(bean.insurederIdCard, bean.insurederIdCardMd5)">查看权益</el-button>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <el-dialog title="权益详情" :visible.sync="dialogTableVisible" width="565px" custom-class="xq-dialog">
                    <el-table style="width: 100%" :header-cell-style="returnStyle" border :data="garmtee">
                      <el-table-column property="premiseAttribute" label="保障项目" align="center"></el-table-column>
                      <el-table-column property="guaranteeMoney" label="保额/详情" align="center"></el-table-column>
                      <emptyBox slot="empty"></emptyBox>
                    </el-table>
                  </el-dialog>
                </div>
              </template>
              <div class="card-body bbxr-card-body clearfix" v-else>
                <div class="triangle-topleft">
                  <span>{{ 1 }}</span>
                </div>
                <div class="info-box">
                  <div class="info-row">
                    <div class="info-lab">姓名</div>
                    <div class="info-val">{{ '-' }}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-lab">性别</div>
                    <div class="info-val">
                      {{ '-' }}
                    </div>
                  </div>
                  <div class="info-row">
                    <div class="info-lab">出生日期</div>
                    <div class="info-val">
                      {{ '-' }}
                    </div>
                  </div>
                  <div class="info-row">
                    <div class="info-lab">证件号码</div>
                    <div class="info-val">{{ '-' }}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-lab">与投保人关系</div>
                    <div class="info-val">
                      {{ '-' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tb-info-card">
              <div class="tb-info-title">受益人</div>
              <div class="tb-info-title1">
                受益人类型：
                <span class="val-info" v-if="detailList.beneficiaryType == '1'">法定受益人</span>
                <span class="val-info" v-if="detailList.beneficiaryType == '2'">指定受益人</span>
                <span class="val-info" v-if="detailList.beneficiaryType == '3'">被保险人</span>
              </div>
              <div class="table-box" v-if="detailList.beneficiaryType == '2'">
                <div class="table-content">
                  <div class="table-row first">
                    <div class="table-col">姓名</div>
                    <div class="table-col">证件号码</div>
                    <div class="table-col">与被保险人关系</div>
                    <div class="table-col">收益比例</div>
                  </div>
                  <div class="table-row" v-for="(item, index) in beneInfo" :key="index">
                    <div class="table-col">
                      {{ item.beneName | filterNull }}
                    </div>
                    <div
                      class="table-col"
                      :class="{ 'can-click': detailList.isDecrypt && item.beneIdCard }"
                      @dblclick="item.beneIdCard && detailList.isDecrypt && descrypt(1, 1, item.beneIdCardMd5, policyNo, 'beneIdCard', item)"
                    >
                      {{ item.beneIdCard | filterNull }}
                    </div>
                    <div class="table-col">
                      {{ item.beneRelationship | filterNull }}
                    </div>
                    <div class="table-col">
                      {{ item.beneRate | filterNull }}
                    </div>
                  </div>
                  <div class="table-row" v-if="beneInfo.length == 0">
                    <div class="table-col" v-for="(t, n) in 4" :key="n">
                      {{ '-' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!-- renewalType为null默认显示续期信息 -->
          <el-tab-pane label="续期信息" name="third" v-if="(detailList.policyNo || renewalRecordGroup.length > 0) && this.checkAuth('renewalList')">
            <div class="tb-info-card">
              <div class="tb-info-title">银行卡信息</div>
              <div class="card-body card-body-padding">
                <div class="info-row">
                  <div class="info-lab">银行卡号</div>
                  <div
                    class="info-val"
                    :class="{ 'can-click': detailList.isDecrypt && detailList.accountNumber }"
                    @dblclick="
                      detailList.accountNumber && detailList.isDecrypt && descrypt(1, 3, detailList.accountNumberMd5, policyNo, 'accountNumber', detailList)
                    "
                  >
                    {{ detailList.accountNumber | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">持卡人</div>
                  <div class="info-val">{{ detailList.policyerName | filterNull }}</div>
                </div>
                <div class="info-row">
                  <div class="info-lab">开户行</div>
                  <div class="info-val">{{ detailList.accountBank | filterNull }}</div>
                </div>
                <div class="info-row">
                  <div class="info-lab">续期周期</div>
                  <div class="info-val">{{ detailList.payType | filterPayType }}</div>
                </div>
              </div>
            </div>
            <div class="tb-info-card">
              <div class="tb-info-title">
                续期信息
                <!-- <span> (仅显示有服务费的期数)</span> -->
              </div>
              <template v-for="(renewalList, n) in renewalRecordGroup">
                <div class="table-top" :key="n">
                  <div class="tb-info-title1" v-if="renewalRecordGroup.length > 1">
                    保单号：<span class="val-info"><tooltip :txt-info="renewalList.policyNo"></tooltip></span>
                  </div>
                  <el-table :data="renewalList.data" border style="width: 100%; margin-bottom: 15px">
                    <el-table-column align="center" prop="payNum" label="期数" width="100px"> </el-table-column>
                    <el-table-column align="center" prop="renewalType" label="类型" width="100px">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.renewalType | filterRenewalType }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="needPayTime" label="应交费日期">
                      <template slot-scope="scope">
                        {{ scope.row.needPayTime | timeSplit }}
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="lastPayTime" label="宽限期满日期" v-if="renewalType == 2">
                      <template slot-scope="scope">
                        {{ scope.row.lastPayTime | timeSplit }}
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="fee" label="应交保费（元）"> </el-table-column>
                    <el-table-column align="center" prop="renewalStatus" label="状态">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row | renewalStatus }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="payTime" label="实际交费日期">
                      <template slot-scope="scope">
                        <!-- 续费成功显示 -->
                        <span v-if="scope.row.renewalStatus == 2">{{ scope.row.payTime | timeSplit }}</span>
                        <span v-else>-</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="payFee" label="实交保费（元）">
                      <template slot-scope="scope">
                        {{ scope.row.payFee | filterNull }}
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
              <!-- 处理空数据 -->
              <template v-if="renewalRecordGroup.length == 0">
                <div>
                  <el-table border style="width: 100%">
                    <el-table-column align="center" label="期数"> </el-table-column>
                    <el-table-column align="center" label="类型"> </el-table-column>
                    <el-table-column align="center" label="应交费日期"> </el-table-column>
                    <el-table-column align="center" label="宽限期满日期" v-if="renewalType == 2"> </el-table-column>
                    <el-table-column align="center" label="应交保费（元）"> </el-table-column>
                    <el-table-column align="center" label="状态"> </el-table-column>
                    <el-table-column align="center" label="实际交费日期"> </el-table-column>
                    <el-table-column align="center" label="实交保费（元）"> </el-table-column>
                    <emptyBox slot="empty"></emptyBox>
                  </el-table>
                </div>
              </template>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务费信息" name="fourth" v-if="detailList.policyNo && this.checkAuth('orderCommission')">
            <commissonsDetail :policyNo="policyNo" :payType="detailList.payType"></commissonsDetail>
          </el-tab-pane>
          <!-- 加保记录 -->
          <el-tab-pane label="加保记录" name="addPolicy" v-if="detailList.addPolicy && detailList.cashValueJump">
            <addPolicyList :policyNo="policyNo"></addPolicyList>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import commissonsDetail from './components/commissonsDetail.vue';
import addPolicyList from './components/addPolicyList.vue';
import tooltip from '@/components/tooltip';
import headBox from '@/components/head.vue';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data: () => ({
    userinfo: {},
    renewalRecordGroup: [], //续期信息分组
    mechanChildShortName: '',
    mechanName: '', // 团队简称
    policyNo: '', // 保单号
    newPolicyNo: '', // 新保单号
    renewalType: '', // 保单类型，1续保 2 续费
    detailList: '', // 保单详情列表
    all: {},
    beneInfo: [], //受益人信息
    garmtee: [], //保障权益
    insuredersJson: [], //被保人信息
    renewalRecord: [], // 续期记录
    commissons: [], // 保单费用
    dialogTableVisible: false,
    activeName: 'first',
    manualList: [], // 人核进度列表
    mechanName: '', // 团队名
    spanArr: [],
    position: '',
    employee: true,
    loading: true
  }),
  created() {
    this.$tools.getall(data => {
      this.all = data;
    });
    this.getPageInfo();
    this.getUserInfo();
  },
  components: { commissonsDetail, tooltip, headBox, addPolicyList },
  methods: {
    getUserInfo() {
      const data = this.$tools.getLocal('userinfo');
      this.userinfo = data;
      // 1一级团队 2二级团队 3员工
      if (data.level == 3) {
        this.employee = false;
      }
    },
    //获得表格数据相同的行数
    rowspan() {
      //每次调用清空数据
      this.spanArr = [];
      this.position = 0;
      this.commissons.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (this.commissons[index].payNum === this.commissons[index - 1].payNum) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      });
    },
    // 表格行合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
      if (columnIndex === 2) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    // 匹配投保人对应的权益
    getGarmteeDetail(idCard, cardMd5) {
      if (this.insuredersJson.length > 1) {
        this.garmtee = this.allgarmtee.filter(item => {
          if (item.insuresCardNo) {
            if (item.insuresCardNo == idCard) {
              return item;
            } else if (item.insuresCardNo == cardMd5) {
              return item;
            }
          }
        });
      } else {
        this.garmtee = this.allgarmtee;
      }
      this.dialogTableVisible = true;
    },
    returnStyle() {
      return { background: '#F7F7F7', 'text-align': 'center', 'font-weight': '400' };
    },
    getPageInfo() {
      this.policyNo = this.$route.query.policyNo;
      this.newPolicyNo = this.$route.query.newPolicyNo;
      this.renewalType = this.$route.query.renewalType;
      this.mechanName = this.$route.query.mechanName;
      this.mechanLevel = this.$route.query.mechanLevel;
      this.gePolicyDetail();
    },
    // 获取保单详情
    gePolicyDetail() {
      this.$http({
        url: '/master/policy/queryRenewalPolicyDetail',
        type: 'put',
        params: {
          policyNo: this.policyNo,
          newPolicyNo: this.newPolicyNo,
          policyType: this.renewalType
        }
      }).then(res => {
        this.loading = false;
        this.detailList = res.data;
        this.insuredersJson = JSON.parse(res.data.insuredersJson);
        if (res.data.garmtee) {
          this.allgarmtee = JSON.parse(res.data.garmtee);
        }
        if (this.detailList.beneInfo) {
          this.beneInfo = JSON.parse(this.detailList.beneInfo);
        }
        this.getRenewalRecord();
      });
    },
    // 获取续期记录
    getRenewalRecord() {
      if (!this.checkAuth('renewalList')) {
        return;
      }
      this.$http({
        url: '/master/policy/queryRenewalRecord',
        type: 'put',
        params: {
          policyNo: this.policyNo
        }
      }).then(res => {
        this.renewalRecord = res.data;
        let map = {},
          dest = [];
        //保单分组
        for (let i = 0, len = this.renewalRecord.length; i < len; i++) {
          let ai = this.renewalRecord[i];
          if (!map[ai.policyNo]) {
            dest.push({
              policyNo: ai.policyNo,
              data: [ai]
            });
            map[ai.policyNo] = ai;
          } else {
            for (let j = 0; j < dest.length; j++) {
              let dj = dest[j];
              if (dj.policyNo == ai.policyNo) {
                dj.data.push(ai);
                break;
              }
            }
          }
        }
        this.renewalRecordGroup = dest;
      });
    }
  },
  filters: {
    filterRenewalType(val) {
      if (val == '' || val == null) {
        return '-';
      } else if (val == 1) {
        return '续保';
      } else if (val == 2) {
        return '续费';
      }
    },
    filterNull(val) {
      if (!val || val == null) {
        return '-';
      } else if (val == '111****1111') {
        return '-';
      }
      return val;
    },
    filterRenewal(val) {
      if (val == 2) {
        return '待续费';
      } else if (val == 5) {
        return '续费成功';
      } else if (val >= 6) {
        return '续费失败';
      }
    },
    filterXbStatus(val) {
      if (val == 2) {
        return '待续保';
      } else if (val == 5) {
        return '续保成功';
      } else if (val >= 6) {
        return '续保失败';
      }
    },
    renewalStatus(val) {
      let str = '';
      if (val.renewalStatus == 1) {
        str = '待续费';
        return str;
      } else if (val.renewalStatus == 2 && val.payNum == 1) {
        return '已支付';
      } else if (val.renewalStatus == 2) {
        str = '续费成功';
        return str;
      } else if (val.renewalStatus >= 3) {
        str = '续费失败';
        return str;
      }
    },
    // 交费状态
    payStatus(val) {
      let str = '';
      if (val == '1' || val == '2') {
        str = '待续费';
        return str;
      } else if (val == '3' || val == '4') {
        str = '已支付';
        return str;
      } else if (val === '5') {
        str = '续费成功';
        return str;
      } else if (val === '6') {
        str = '续费失败';
        return str;
      }
    },
    filterPayment(val) {
      if (val == '4') {
        return '趸交';
      } else if (val == '5') {
        return '终身';
      } else if (val == '6' || val == '1') {
        return '年';
      } else if (val == '2') {
        return '月';
      }
    }
  }
};
</script>
<style lang='scss' scoped>
@import './order_xfd_detail';
</style>
<style lang='scss'>
.xq-dialog {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  letter-spacing: 1px;
  .el-dialog__body {
    padding-top: 10px;
  }
}
</style>